let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3kHns"), load("3JzPO"), load("h5Eq0")]).then(() => parcelRequire('8IuF3'));